"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimPerpetualLoanv2 = void 0;
const common_1 = require("../../../../../common");
const constants_1 = require("../../../../constants");
const helpers_1 = require("../../../../helpers");
const offer_1 = require("../../offer");
const anchor_1 = require("@coral-xyz/anchor");
const token_1 = require("@coral-xyz/anchor/dist/cjs/utils/token");
const banxAdventure_1 = require("../../../banxStaking/banxAdventure");
const claimPerpetualLoanv2 = (_a) => __awaiter(void 0, [_a], void 0, function* ({ programId, connection, accounts, sendTxn, }) {
    const program = (0, helpers_1.returnAnchorProgram)(connection);
    const instructions = [];
    const [banxStakingSettings] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_STAKING_SETTINGS_PREFIX)], program.programId);
    const [mutualBondTradeTxnVault] = anchor_1.web3.PublicKey.findProgramAddressSync([constants_1.ENCODER.encode(constants_1.MUTUAL_BOND_TRADE_TXN_VAULT)], program.programId);
    const userTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(accounts.userPubkey, accounts.collateralTokenMint);
    const mutualBondTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(mutualBondTradeTxnVault, accounts.collateralTokenMint);
    const collateralTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(accounts.collateralOwner, accounts.collateralTokenMint);
    const editionInfo = (0, helpers_1.getMetaplexEditionPda)(accounts.collateralTokenMint);
    const nftMetadata = (0, helpers_1.getMetaplexMetadata)(accounts.collateralTokenMint);
    const ownerTokenRecord = (0, helpers_1.findTokenRecordPda)(accounts.collateralTokenMint, collateralTokenAccount);
    const middleTokenRecord = (0, helpers_1.findTokenRecordPda)(accounts.collateralTokenMint, mutualBondTokenAccount);
    const destTokenRecord = (0, helpers_1.findTokenRecordPda)(accounts.collateralTokenMint, userTokenAccount);
    const ruleSet = accounts.ruleSet;
    const currentWeek = (0, banxAdventure_1.banxAdventureTimestampToWeeks)((0, offer_1.nowInSeconds)());
    const [banxAdventureSubscription] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_SUBSCRIPTION_PREFIX), accounts.collateralOwner.toBuffer()], program.programId);
    const [banxTokenStake] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_TOKEN_STAKE_PREFIX), accounts.collateralOwner.toBuffer()], program.programId);
    const remainingAccounts = [
        {
            pubkey: ownerTokenRecord,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: middleTokenRecord,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: destTokenRecord,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: accounts.banxStake,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: banxTokenStake,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: banxAdventureSubscription,
            isSigner: false,
            isWritable: true,
        },
    ];
    let tokenAccount = yield connection.getAccountInfo(userTokenAccount);
    if (!tokenAccount) {
        instructions.push(...(0, common_1.createAssociatedTokenAccountInstruction)(userTokenAccount, accounts.userPubkey, accounts.userPubkey, accounts.collateralTokenMint));
    }
    instructions.push(yield program.methods
        .claimPerpetualLoanV2(null)
        .accountsStrict({
        bondTradeTransaction: accounts.bondTradeTransaction,
        fbond: accounts.fbond,
        mutualBondTradeTxnVault: mutualBondTradeTxnVault,
        tokenMint: accounts.collateralTokenMint,
        collateralOwner: accounts.collateralOwner,
        collateralTokenAccount: collateralTokenAccount,
        userTokenAccount: userTokenAccount,
        mutualBondTokenAccount: mutualBondTokenAccount,
        user: accounts.userPubkey,
        authRules: ruleSet || constants_1.EMPTY_PUBKEY,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        tokenProgram: token_1.TOKEN_PROGRAM_ID,
        associatedTokenProgram: token_1.ASSOCIATED_PROGRAM_ID,
        metadataProgram: constants_1.METADATA_PROGRAM_PUBKEY,
        metadata: nftMetadata,
        instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
        authorizationRulesProgram: constants_1.AUTHORIZATION_RULES_PROGRAM,
        banxStakingSettings,
        edition: editionInfo
    })
        .remainingAccounts(remainingAccounts)
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [];
    yield sendTxn(transaction, signers);
    return {
        accounts: {
            fraktBond: accounts.fbond,
            bondOffer: accounts.bondOffer,
            bondTradeTransaction: accounts.bondTradeTransaction,
            banxAdventureSubscription,
            banxStakingSettings,
            banxTokenStake,
            banxStake: accounts.banxStake,
        },
        instructions, signers
    };
});
exports.claimPerpetualLoanv2 = claimPerpetualLoanv2;
